/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './icon.less';
import throttle from 'lodash/throttle'
export interface MakeIconOptions {
  text?: string;
  svg?: string;
  title?: string;
  onClick?: (this: HTMLElement, event: MouseEvent) => void;
  throttleClick?: Function,
  href?: string;
  shape?: string
  disabled?: boolean
  throttleInterval?: number,
  innerElement?: HTMLElement,  
  classList?: string[],
  checked?: string,
  onChange?: (this: HTMLElement, event: Event) => void;
}

export function makeIcon(options: MakeIconOptions): HTMLElement {
  const {title, onClick, href, shape, disabled = false, throttleClick, throttleInterval = 1000, classList, checked, innerElement, onChange} = options;
  let element: HTMLDivElement|HTMLAnchorElement;
  if (href !== undefined) {
    element = document.createElement('a');
    element.href = href;
    element.target = '_blank';
  } else {
    element = document.createElement('div');
  }
  if (shape !== undefined) {
    element.classList.add(shape)
  }
  if (title !== undefined) {
    element.title = title;
  }
  if(checked !== undefined){
    element.dataset.checked = checked;
  }
  if (throttleClick !== undefined) {
    const func = throttle(() => {
      if (element.dataset.activated = 'false')
      element.dataset.activated = 'true'
      throttleClick();
      setTimeout(() => {
        element.dataset.activated = 'false'
      }, throttleInterval)
    }, throttleInterval);
    element.addEventListener('click', func);
  }
  if (classList !== undefined) {
    element.classList.add(...classList);
  }
  if (onClick !== undefined) {
    element.addEventListener('click', onClick);
  }
   if (onChange !== undefined) {
    element.addEventListener('change', onChange);
   }
   if (classList !== undefined){
    element.classList.add(...classList);
   }
  if (disabled) {
    element.classList.add('disabled')
  }
  const {svg} = options;
  element.classList.add('neuroglancer-icon');
  if (svg !== undefined) {
    element.innerHTML = svg;
  }
  if(innerElement){
    element.appendChild(innerElement);
  }
  if (options.text !== undefined) {
    element.appendChild(document.createTextNode(options.text));
  }
  return element;
}
